/**
 * Etiquetas de metodología compartidas por la pestaña Metodologías y su
 * detalle.
 */

import { useTranslation } from 'react-i18next'

import type { Methodology, MethodologyStatus } from '../../../api/methodologies'

const STATUS_CLASS: Record<MethodologyStatus, string> = {
  draft: 'bg-surface-muted text-ink-subtle',
  published: 'bg-official-soft text-official',
  archived: 'bg-surface-muted text-ink-subtle line-through',
}

export function MethodologyStatusChip({ status }: { status: MethodologyStatus }) {
  const { t } = useTranslation('templates')
  return (
    <span
      className={`px-1.5 py-0.5 rounded text-[9px] font-medium uppercase tracking-wider ${STATUS_CLASS[status]}`}
    >
      {t(`methodologies.status.${status}`)}
    </span>
  )
}

/** "Predeterminada del producto" / "de la organización", si aplica. */
export function MethodologyDefaultBadges({
  methodology,
}: {
  methodology: Methodology
}) {
  const { t } = useTranslation('templates')
  return (
    <>
      {methodology.is_default ? (
        <span className="px-1.5 py-0.5 rounded text-[9px] font-medium uppercase tracking-wider bg-brand-soft text-brand">
          {t('methodologies.default_product')}
        </span>
      ) : null}
      {methodology.is_tenant_default ? (
        <span className="px-1.5 py-0.5 rounded text-[9px] font-medium uppercase tracking-wider bg-brand-soft text-brand">
          {t('methodologies.default_tenant')}
        </span>
      ) : null}
    </>
  )
}
